import { db } from '../../utils/firebase';

export const getAllAreas = async () => {
  const querySnapshot = await db.collection("areas").get();

  const areas = [];
  querySnapshot.forEach(doc => {
    areas.push(doc.data());
  });

  return areas;
};